import { memo } from "react";
import BoolIndicator from "components/StatusIndicators/BoolIndicator";

interface ApprovalStatusCellRendererProps {
  value: boolean;
}

/**
 * Cell renderer for approval status that shows standard checkbox icons
 * with colors - green for approved, red for unapproved
 */
export const ApprovalStatusCellRenderer = ({
  value,
}: ApprovalStatusCellRendererProps) => {
  return (
    <BoolIndicator
      value={value}
      truthyText="Approved"
      falsyText="Not Approved"
      type="icon"
      applyColor={true} // Green for approved, red for unapproved
    />
  );
};

export default memo(ApprovalStatusCellRenderer);
